import store from '@/store';
import {AlertColor, AlertOptions} from '@/store/modules/alert';

export default class Alert {
  fire(options: AlertOptions) {
    return store.dispatch('alert/fire', options);
  }

  show(message: string, type?: AlertColor | string, options?: AlertOptions) {
    return store.dispatch('alert/show', {message, type, options});
  }

  success(message: string, options?: AlertOptions) {
    return this.show(message, 'success', options);
  }

  error(message: string, options?: AlertOptions) {
    return this.show(message, 'error', options);
  }

  info(message: string, options?: AlertOptions) {
    return this.show(message, 'info', options);
  }

  warning(message: string, options?: AlertOptions) {
    return this.show(message, 'warning', options);
  }

  catchError(e: any) {
    return this.error(
      e.response?.data?.message || e.message || 'Internal Server Error',
    );
  }

  hide() {
    return store.dispatch('alert/hide');
  }
}
